import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Context/Handlers/LoadSettings";

export type HandlerType = Parameters<typeof RequestDataFromApi>[0];

addToChainAfter(chain, RequestDataFromApi, ParseCustomSettings);

const enum fields {
  preferredResellerIconPath = "preferredResellerIconPath",
}

function ParseCustomSettings(props: HandlerType) {
    const settingsModel = props.apiResult;

    if (settingsModel.properties[fields.preferredResellerIconPath] !== undefined) {
        props.apiResult.settingsCollection.customSettings = {
            preferredResellerIconPath: settingsModel.properties[fields.preferredResellerIconPath],
        };
    }
}
